// Helpers
import { dateTimeDisplay } from '../userInvitationsHelpers'

const InvitationStatus = props => {
  return (
    (props.invitation.invitation_accepted) ?
      <span className="invite-accepted">Accepted</span> :
      (
        (moment(props.invitation.expires_at) < moment()) ?
          <span className="invite-expired">Expired</span> :
          <span className="invite-pending">
            Expires: <small>{dateTimeDisplay(props.invitation.expires_at)}</small>
          </span>
      )
  )
}

export default InvitationStatus


// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/user-invitations/components/InvitationStatus.js